import React, { useState, useEffect } from 'react';
import { Toaster } from '@/components/ui/toaster';
import { Toaster as SonnerToaster } from 'sonner';
import { AuthProvider } from '@/providers/AuthProvider';
import { QueryProvider } from '@/providers/QueryProvider';
import AppRoutes from './routes/AppRoutes';
import { QuickChargeProvider } from '@/components/payment';
import SuspensionGuard from '@/components/layout/SuspensionGuard';
import Joyride from 'react-joyride';
import './App.css';
import { UpdatePrompt } from '@/components/UpdatePrompt';
import { useAuth } from '@/hooks/useAuth';

export function MainApp() {
  const [run, setRun] = useState(false); // Disabled tour to fix page flicker
  const steps = [
    {
      target: '.dashboard-header',
      content: 'This is your dashboard header. It shows your organization and a welcome message.',
    },
    {
      target: '.business-metrics',
      content: 'Here are your key business metrics at a glance.',
    },
    {
      target: '.smart-suggestions',
      content: 'Get AI-powered suggestions to improve your business.',
    },
    {
      target: '.activity-feed',
      content: 'See recent activity and updates from your hive.',
    },
  ];

  return (
    <>
      <UpdatePrompt />
      <Joyride
        steps={steps}
        run={run}
        continuous
        showSkipButton
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      />
      <QueryProvider>
        <AuthProvider>
          <MainAppWithAuth />
        </AuthProvider>
      </QueryProvider>
    </>
  );
}

function MainAppWithAuth() {
  const { user, ready } = useAuth();

  // Check if signup is in progress - if so, don't block on ready state
  const signupInProgress = sessionStorage.getItem('signup-in-progress') === 'true';
  
  if (!ready && !signupInProgress) {
    return null; // Block all rendering until auth is ready
  }

  return (
    <QuickChargeProvider>
      <SuspensionGuard>
        <AppRoutes />
        <Toaster />
        <SonnerToaster position="top-right" />
      </SuspensionGuard>
    </QuickChargeProvider>
  );
}